import { isApiError } from '@/shared/api'

import { Stack } from './Stack'
import { Text } from './Text'

export function ErrorDetails({ error }: { error: unknown }) {
  if (!isApiError(error)) {
    return null
  }

  const { reason, ...measured } = error.details
  const rest = Object.entries(measured)

  if (!reason && rest.length === 0) {
    return null
  }

  return (
    <Stack gap="xs">
      {reason ? <Text role="body">{reason}</Text> : null}
      {rest.length > 0 ? (
        <Text role="caption">{rest.map(([name, value]) => `${name}=${value}`).join(' · ')}</Text>
      ) : null}
      {error.requestId ? <Text role="caption">{`request_id=${error.requestId}`}</Text> : null}
    </Stack>
  )
}
